var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadPhoto({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.07,
    height: 48.818,
    viewBox: "0 0 52.07 48.818",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10 -40.6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 40.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.035,66.635,49.053,53.617h-9.76V40.6H32.783V53.617H23.018Zm11.833-5.324-3.65,3.65,13.23,4.931L36.035,77.873,14.623,69.892l13.225-4.931-3.65-3.65L10,66.635V79.653l26.035,9.766L62.07,79.653V66.635Z",
    transform: "translate(-10 -40.6)",
    fill: "#a19f9d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadPhoto);
export default __webpack_public_path__ + "static/media/uploadPhoto.162ac1e5603d63d94098f68403dbf55f.svg";
export { ForwardRef as ReactComponent };